/* action types */
export const types = {
	TOGGLE_MODE: 'USER/TOGGLE_MODE',
};

const CREATE_EDIT_PERMISSIONS = [
	'video-create', 'video-edit',
	'image-create', 'image-edit',
	'document-create', 'document-edit',
	'contact-create', 'contact-edit',
	'feedback-create', 'feedback-edit',
	'link-create', 'link-edit',
	'form-create', 'form-edit'
];

const BUNDLE_PERMISSIONS = [
	'bundle-video-create', 'bundle-video-edit',
	'bundle-image-create', 'bundle-image-edit',
	'bundle-document-create', 'bundle-document-edit',
	'bundle-contact-create', 'bundle-contact-edit',
	'bundle-feedback-create', 'bundle-feedback-edit',
	'bundle-link-create', 'bundle-link-edit',
	'bundle-form-create', 'bundle-form-edit'
];

/* initial state */
export const initialState = {
	user: {
		permissions: [...CREATE_EDIT_PERMISSIONS, ...BUNDLE_PERMISSIONS],
	}
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.TOGGLE_MODE:
			return {
				...state,
				user: {
					...state.user,
					permissions: state.user.permissions
				}
			};

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	toggleMode: () => ({ type: types.TOGGLE_MODE }),
};

export const dispatchActions = {
	toggleUserMode: () => dispatch => dispatch(actions.toggleMode())
};


// WEBPACK FOOTER //
// ./src/components/user/userHandlerRedux.jsx